export const getisIOS = (): boolean => {
  if (typeof navigator === 'undefined') {
    return false;
  }
  const { userAgent } = navigator;

  if (!userAgent) return false;

  // Classic iOS
  const isClassicIOS = /iPhone|iPad|iPod/.test(userAgent);

  // iPadOS 13+
  const isIPadOS13Plus = /Macintosh/.test(userAgent) && /Mobile/.test(userAgent);

  return isClassicIOS || isIPadOS13Plus;
};
